import { render, staticRenderFns } from "./EditLocalCharge.vue?vue&type=template&id=f0226b34&scoped=true&"
import script from "./EditLocalCharge.vue?vue&type=script&lang=js&"
export * from "./EditLocalCharge.vue?vue&type=script&lang=js&"
import style0 from "./EditLocalCharge.vue?vue&type=style&index=0&id=f0226b34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0226b34",
  null
  
)

export default component.exports